import { RootState } from '@/store';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Range } from '@tiptap/core';

const initialState = {
  slashCommand: {
    query: '',
    range: null as Range | null
  }
} as {
  slashCommand: {
    query: string;
    range: Range | null;
  };
};

const slice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setSlashQuery: (state, action: PayloadAction<string>) => {
      state.slashCommand.query = action.payload;
    },
    setSlashRange: (state, action: PayloadAction<Range | null>) => {
      state.slashCommand.range = action.payload;
    },
    clearSlashCommand: (state) => {
      state.slashCommand.query = '';
      state.slashCommand.range = null;
    }
  }
});

export const { setSlashQuery, setSlashRange, clearSlashCommand } = slice.actions;

export default slice.reducer;

export const selectSlashQuery = (state: RootState): string =>
  state.editor.slashCommand.query;

export const selectSlashRange = (state: RootState): Range | null =>
  state.editor.slashCommand.range;


